import React, { FunctionComponent } from 'react';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { DropdownComponentProps } from './DropdownComponent.types';
import './DropdownComponent.scss';

export const DropdownComponent: FunctionComponent<
  DropdownComponentProps
> = props => {
  const {
    id,
    labelId,
    value,
    defaultValue,
    onChange,
    formClassName,
    className,
    label,
    itemsToSelect,
    variant,
  } = props;
  return (
    <FormControl variant={variant} className={formClassName}>
      {label ? <InputLabel id={labelId}>{label}</InputLabel> : null}
      <Select
        labelId={labelId}
        id={id}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        className={className}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {itemsToSelect.map((item, ix) => (
          <MenuItem
            style={{ whiteSpace: 'normal' }}
            key={`${ix}_${item.name}_${item.value}`}
            value={item.value}
          >
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
